import React, { useEffect, useState } from "react";
import axios from "axios";
import { Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { PlusLg, TrashFill } from "react-bootstrap-icons";

export default function GalleryUpload({ religiousAffiliationId, images: initialImages = [] }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const AuthToken = localStorage.getItem("AuthUser");

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${AuthToken}`;

  useEffect(() => {
    setImages(initialImages);
  }, [initialImages]);

  const uploadImage = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const formData = new FormData();
    formData.append("affiliation_id", religiousAffiliationId);
    formData.append("img", file);

    try {
      setLoading(true);

      const res = await axios.post(
        process.env.REACT_APP_API_URL +
          "/religious-affiliation-gallery-upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Laravel returns the created record
      setImages((prev) => [...prev, res.data.data]);

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const deleteImage = async (id) => {
    if (!window.confirm("Delete this image?")) return;

      try {
        await axios.delete(
          process.env.REACT_APP_API_URL +
            "/religious-affiliation-gallery/" +
            id
        );

        setImages((prev) =>
          prev.filter((item) => item.id !== id)
        );
      } catch (err) {
        console.log(err);
      }
    };

  return (
    <Row className="g-3">

      {images.map((item) => (
        <Col md={3} sm={6} xs={12} key={item.id}>
          <Card className="shadow-sm">

            <Card.Img
              variant="top"
              src={`${process.env.REACT_APP_IMG_URL}${item.img}`}
              style={{
                height: 180,
                objectFit: "cover",
              }}
            />

            <Card.Body className="text-center">

              <Button
                variant="danger"
                size="sm"
                onClick={() => deleteImage(item.id)}
              >
                <TrashFill /> Delete
              </Button>

            </Card.Body>
          </Card>
        </Col>
      ))}

      <Col md={3} sm={6} xs={12}>
        <Card
          className="shadow-sm d-flex justify-content-center align-items-center"
          style={{
            height: 240,
            cursor: "pointer",
            border: "2px dashed #0d6efd",
          }}
          onClick={() =>
            document.getElementById("galleryInput").click()
          }
        >
          {loading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <PlusLg size={40} className="text-primary" />
              <div className="mt-2">Add Image</div>
            </>
          )}
        </Card>

        <input
          id="galleryInput"
          type="file"
          hidden
          accept="image/*"
          onChange={uploadImage}
        />
      </Col>
    </Row>
  );
}